import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import '../styles/Vehicles.css';
import backendUrl from '../BackendUrl';

const Vehicles = () => {
  // Get the model id from the URL (e.g., /vehicles/:id)
  const { id } = useParams();

  // State for model data
  const [modelData, setModelData] = useState(null);
  const [modelLoading, setModelLoading] = useState(true);
  const [modelError, setModelError] = useState(null);

  // State for trim data (for the "classic" trim)
  const [trimData, setTrimData] = useState(null);
  const [trimLoading, setTrimLoading] = useState(true);
  const [trimError, setTrimError] = useState(null);

  // 1. Fetch the model data using the model id
  useEffect(() => {
    axios
      .get(`${backendUrl}/api/vehicles/get-model/${id}`)
      .then((response) => {
        setModelData(response.data);
        setModelLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching model data:', error);
        setModelError('Failed to fetch model data.');
        setModelLoading(false);
      });
  }, [id]);

  // 2. Once the model is loaded, fetch the trim data for the "classic" trim
  useEffect(() => {
    if (modelData && modelData._id) {
      axios
        .get(`${backendUrl}/api/vehicles/get-trim`, {
          params: {
            vehicleModelId: modelData._id,
            trim: 'classic'
          }
        })
        .then((response) => {
          // Find the classic trim for this model that is ready
          const trims = Array.isArray(response.data) ? response.data : [response.data];
          const classicTrim = trims.find(t => t.vehicleModelId === modelData._id && t.trim === 'classic' && t.ready);
          setTrimData(classicTrim);
          setTrimLoading(false);
        })
        .catch((error) => {
          console.error('Error fetching trim data:', error);
          setTrimError('Failed to fetch trim data.');
          setTrimLoading(false);
        });
    }
  }, [modelData]);

  // Render the model details first
  if (modelLoading) {
    return <div>Loading model details...</div>;
  }
  if (modelError) {
    return <div>{modelError}</div>;
  }
  if (!modelData) {
    return <div>No model data available.</div>;
  }
  if (!modelData.ready) {
    return <div>This model is not available.</div>;
  }

  // Helper: Render a spec row if value is present
  const renderSpecRow = (label, value, unit = "") =>
    value !== undefined && value !== null && value !== "" ? (
      <div className="spec-row">
        <span className="spec-label">{label}:</span>
        <span className="spec-value">
          {value}
          {unit}
        </span>
      </div>
    ) : null;

  return (
    <div className="vehicle-model-container">
      {/* Model Card */}
      <div className="model-card">
        <h1>{modelData.model}</h1>
        <img
          src={modelData.modelImg}
          alt={modelData.model}
          className="model-image"
        />
        <p>{modelData.description}</p>
      </div>

      {/* Trim & Specs Card */}
      <div className="trim-card">
        {trimLoading ? (
          <p>Loading trim details...</p>
        ) : trimData ? (
          <div className="trim-details">
            <h2>Specifications:</h2>
            <div className="specs-list">
              {renderSpecRow("Engine", trimData.engine)}
              {renderSpecRow("Transmission", trimData.transmission)}
              {renderSpecRow("MPG City", trimData.mpgCity, " mpg")}
              {renderSpecRow("MPG Highway", trimData.mpgHwy, " mpg")}
              {renderSpecRow("MPG Combined", trimData.mpgCmb, " mpg")}
              {renderSpecRow("Mileage", trimData.mileage, " mi")}
              {renderSpecRow("Weight", trimData.weight, " lbs")}
              {renderSpecRow("Seats", trimData.seats)}
            </div>
            {/* Build & Price Button */}
            <div className="build-price-container">
              <Link to="/buildnprice" className="build-price-button">
                Build & Price
              </Link>
            </div>
          </div>
        ) : trimError ? (
          <p>{trimError}</p>
        ) : (
          <p>No trim data available.</p>
        )}
      </div>
    </div>
  );
};

export default Vehicles;